__turbopack_context__.v({
  "aboutbox1": "about-forestry-module__MYy9Na__aboutbox1",
  "aboutheading1": "about-forestry-module__MYy9Na__aboutheading1",
  "aboutheading2": "about-forestry-module__MYy9Na__aboutheading2",
  "aboutnumber": "about-forestry-module__MYy9Na__aboutnumber",
  "aboutparagraph1": "about-forestry-module__MYy9Na__aboutparagraph1",
  "acheivername": "about-forestry-module__MYy9Na__acheivername",
  "acheivernamespecial": "about-forestry-module__MYy9Na__acheivernamespecial",
  "acheiverrank": "about-forestry-module__MYy9Na__acheiverrank",
  "acheiverrankspecial": "about-forestry-module__MYy9Na__acheiverrankspecial",
  "active": "about-forestry-module__MYy9Na__active",
  "classesborder": "about-forestry-module__MYy9Na__classesborder",
  "content": "about-forestry-module__MYy9Na__content",
  "dot": "about-forestry-module__MYy9Na__dot",
  "facultyborder3": "about-forestry-module__MYy9Na__facultyborder3",
  "form-control": "about-forestry-module__MYy9Na__form-control",
  "nav-item": "about-forestry-module__MYy9Na__nav-item",
  "nav-link": "about-forestry-module__MYy9Na__nav-link",
  "nav-pills": "about-forestry-module__MYy9Na__nav-pills",
  "nav-tabs": "about-forestry-module__MYy9Na__nav-tabs",
  "numberbold": "about-forestry-module__MYy9Na__numberbold",
  "pagemaintitle": "about-forestry-module__MYy9Na__pagemaintitle",
  "redunderline": "about-forestry-module__MYy9Na__redunderline",
  "redunderlinealink": "about-forestry-module__MYy9Na__redunderlinealink",
  "sectionredtitle": "about-forestry-module__MYy9Na__sectionredtitle",
  "sectionsubtitle": "about-forestry-module__MYy9Na__sectionsubtitle",
  "sectiontitle": "about-forestry-module__MYy9Na__sectiontitle",
  "show": "about-forestry-module__MYy9Na__show",
  "star": "about-forestry-module__MYy9Na__star",
  "tabactive": "about-forestry-module__MYy9Na__tabactive",
  "tablinks": "about-forestry-module__MYy9Na__tablinks",
  "tabscrollclass": "about-forestry-module__MYy9Na__tabscrollclass",
  "tlitem": "about-forestry-module__MYy9Na__tlitem",
  "tlitem1": "about-forestry-module__MYy9Na__tlitem1",
  "tlitem2": "about-forestry-module__MYy9Na__tlitem2",
  "ulclass": "about-forestry-module__MYy9Na__ulclass",
  "ulliclass": "about-forestry-module__MYy9Na__ulliclass",
  "ullispan": "about-forestry-module__MYy9Na__ullispan",
});
